/*
 *  jquery.ih.supermenu
 *
 * Create our own custom contextmenu to replace the native window one.
 * Also useful for other popup type menus.
 *
 * This is a singleton. Only one instance can be open at a time.
 * This creates itself upon instantiation and destroys itself on close.
 * 
 *
 *  Depends:
 *      jQuery
 *      jquery.ui.position
 *      jquery.ui.menu
 *      supermenu.css
 *      
 *
 * Usage:
 * 
 * $(".some-container-area").on("contextmenu", function(e) {
 *      e.preventDefault();
 *      
 *      // the context menu uses the positioning from the event
 *      $(templates.mymenu).supermenu({ event: e });
 * });
 * 
 * $(".some-menu-toggle").on("click", function() {
 * });
 * 
 * // handy to predefine your menus if there are multiple configurations
 * var templates = {
 *      mymenu: 
 *          "<ul>" + 
 *              "<li data-action='delete'><span class='ih-icon-remove'></span> delete</li>" +
 *              "<li>-</li>" + 
 *              "<li data-action='upload'><span class='ih-icon-upload'></span> upload</li>" +
 *          "</ul>"
 * };
 *
 */
(function($) {

    // extend the jquery ui menu widget with some extra functionality
    $.widget( "ih.supermenu", $.ui.menu, {
        options: {
            icons: {
                submenu: "ih-icon-angle-right"
            },
            items: "> *",
            menus: "ul",
            position: { // jquery ui position of submenus relative to their parent
                my: "left-1 top",
                at: "right top"
            },
            role: "menu",
            
            // menu is appended to the container
            container: 'body',
            
            // jquery ui position object for the main menu
            // use false if you want to just append the menu to the container instead of positioning it.
            menuPosition: { my: 'left top', at: 'left top' },
            
            // if you provide an event with pageX/Y coordinates, it will be used for the "of" property
            // of the menuPosition above
            event: false,

            // set to true to position the menu position fixed 
            // if there is an event provided, it will use the its clientX/Y coordinates instead.
            // (this actually creates a helper element as child of the container with the clientX/Y coordinates, 
            // then uses the helper element as the "of" value for the position)
            fixed: false,

            // provide an element, jQuery obj, or selector here to use as the "of" property of the 
            // menuPosition
            toggleElement: false,

            // close the menu when selecting one of it's items
            closeOnSelect: true,
            
            // close the menu when clicking anywhere else on the page
            closeOnClickOut: true,

            // callbacks
            blur: null,
            focus: null,
            select: null
        },
        
        _create: function() {
            var that = this;

//            console.log("create supermenu!");
            
            // search and destroy any supermenus that already exist
            var $oldMenus = $(".ih-supermenu");
            if ( $oldMenus.length ) {
                $oldMenus.each( function() {
                    if ( $(this).data().ihSupermenu ) {
//                        console.log("destroying old supermenu");
                        $(this).supermenu("destroy");
                    }
                });
            }
            
            // make sure document scope is correct
            this.document = $(this.element[0].ownerDocument);
            
            // do the normal menu create stuff
            this._super();
            
            
            this.document = $(this.element[0].ownerDocument);
            this.parentDocument = (window.top !== window.self) ? $(window.top) : false;
            
            
            this.helper = false;
            
            // if we are positioning the menu, and if there is an event with coordinates, 
            // use it for the positioning
            if ( this.options.menuPosition ) {
                if ( this.options.event ) {
                    // spin up a helper element and use it for positioning instead
                    // using the clientX/Y coords of the event
                    if ( this.options.fixed ) {
                        this.helper = $("<div class='ih-supermenu-helper'></div>")
                            .css({ 
                                position: "absolute", 
                                height: 0, 
                                width: 0, 
                                zIndex: 10000,
                                background: "red", 
                                top: that.options.event.clientY, 
                                left: that.options.event.clientX 
                            })
                            .appendTo(that.options.container);
                    }
                    this.options.menuPosition.of = ( this.helper.length ) ? this.helper : this.options.event;
                }
                else if ( this.options.toggleElement ) {
                    this.options.menuPosition.of = (this.options.menuPosition.of) ? this.options.menuPosition.of : this.options.toggleElement;
                }
                else if ( this.options.container !== "body" ) {
                    this.options.menuPosition.of = (this.options.menuPosition.of) ? this.options.menuPosition.of : this.options.container;
                }
            }
//            console.log("options", this.options);
            
            if ( this.options.toggleElement ) {
                $( this.options.toggleElement ).addClass("ih-supermenu-toggle");
            }
            
            // add our secret sauce
            this.element.addClass("ih-supermenu");
            
            if ( this.options.menuPosition ) {
                this.element.css({ position: "absolute", top: -1000, left: -1000 }) // have it offscreen when appended to avoid flicker
                    .appendTo( that.options.container )
                    .position( that.options.menuPosition ); // positioning with collision detection
            }
            else {
                this.element.appendTo( that.options.container );
            }
            
            // Undo some of the basic setup from ui.menu. 
            // It makes the submenu hide the first time a submenu item is clicked.
            this._off( this.element, "blur" );
            this._off( this.document );

            // need a delay for this event because in FF, the same click that initiated the menu bubbles up to the document 
            // and triggers it to auto close
            setTimeout( function() {
                that.element.addClass("ih-supermenu-open").focus();
                
                
                that.document = $(that.element[0].ownerDocument);
                
                // clicks on anything other than the menu or the toggle element will destroy it
                that._on( that.document, {
                    click: function( event ) {
//                        console.log("click on document!");
                        if ( that._closeOnDocumentClick( event ) ) {
                            that.destroy();
                        }
                        that.mouseHandled = false;
                    }
                });
                
                if ( that.parentDocument ) {
                    that._on( that.parentDocument, {
                        click: function( event ) {
//                            console.log("click on parent document!");
                            if ( that.options.closeOnClickOut ) {
                                that.destroy();
                            }
                            that.mouseHandled = false;
                        }
                    });
                }
                
            }, 100);
        },

        select: function( event ) {
            // original menu stuff and callback
            this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
            var ui = { item: this.active };
            if ( ! this.active.has( ".ui-menu" ).length ) {
                if ( this.options.closeOnSelect ) {
                    this.collapseAll( event, true );
                }
            }
            this._trigger( "select", event, ui );
            
            // trigger a document level custom event and destroy the menu
            // if the selected item has a data action value
            var action = ui.item.data("action");
            if ( action ) {
                $(this.document).trigger("ih.supermenuSelect", ui.item.data() );
                
                if ( this.options.closeOnSelect ) {
                    this.destroy();
                }
                // if we're not closing the menu, we may need to udpate the UI
                else {
//                    if ( ui.item.is(".ih-checklist-item") ) {
                        var property = ui.item.data("property");
                        ui.item.addClass("ih-selected").siblings(".ih-selected").removeClass("ih-selected");
                        
                        if ( property ) {
                            ui.item.siblings("[data-action='" + action + "'][data-property='" + property + "']").removeClass("ih-selected");
                        }
                        else {
                            ui.item.siblings("[data-action='" + action + "']").removeClass("ih-selected");
                        }
//                    }
                }
            }
        },

        // when clicking somewhere on the document, decide whether or not to 
        // trigger the menu to close
        _closeOnDocumentClick: function( event ) {
            if ( this.options.closeOnClickOut ) {
                $target = $( event.target );
                
                // do not close if clicking on or inside either a toggle element or the menu itself
                if ( $target.is( ".ih-supermenu-toggle" ) || $target.closest(".ih-supermenu-toggle").length ) return false;
                if ( $target.is( ".ih-supermenu" ) || $target.closest( ".ih-supermenu" ).length ) return false;
                
                return true;
            }
            
            return false;
        },

        collapseAll: function( event, all ) {
            clearTimeout( this.timer );
            this.timer = this._delay(function() {
                // If we were passed an event, look for the submenu that contains the event
                var currentMenu = all ? this.element :
                    $( event && event.target ).closest( this.element.find( ".ui-menu" ) );

                // If we found no valid submenu ancestor, use the main menu to close all sub menus anyway
                if ( !currentMenu.length ) {
                    currentMenu = this.element;
                }

                this._close( currentMenu );

                this.blur( event );
                this.activeMenu = currentMenu;
            }, this.delay );
        },


        // remove the menu element itself
        destroy: function() {
            
            this._trigger( "close", null, null);
            
//            console.log("destroy!");
            
            if ( this.parentDocument ) {
                this._off( this.parentDocument );
            }
            
            this._super();
            $(".ih-supermenu-toggle").removeClass("ih-supermenu-toggle");
            this.element.remove();
            if ( this.helper ) this.helper.remove();
        }
    });

})(jQuery);
